import { paginationParams } from "@/utils/pagination";
import request from "@/utils/request";
import { cleanObjectFromUndefined } from "@/utils/utils";

export async function getVPCLocations({ page = 1, pageSize = 10, filter = "", sorting }) {
  const { SkipCount, MaxResultCount } = paginationParams(page, pageSize);
  const params = cleanObjectFromUndefined({
    SkipCount,
    MaxResultCount,
    FilterText: filter || undefined,
    sorting: sorting ?? undefined,
  });

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/nissan-service/vpc-locations`, {
    method: "GET",
    params,
  });

  return result?.data;
}

export async function getVPCLocationById(vpcLocationId) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/nissan-service/vpc-locations/${vpcLocationId}`, {
    method: "GET",
  });

  return result?.data;
}

export async function createVPCLocation(vpcLocation) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/nissan-service/vpc-locations`, {
    method: "POST",
    data: vpcLocation,
  });

  if ("error" in result) {
    throw new Error(result?.error);
  }

  return result?.data;
}

export async function updateVPCLocation(vpcLocation) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/nissan-service/vpc-locations/${vpcLocation.id}`, {
    method: "PUT",
    data: vpcLocation,
  });

  if ("error" in result) {
    throw new Error(result?.error);
  }

  return result?.data;
}
